import {PureComponent} from "react";
import * as React from "react";
import LayerListRowFeature from './layer-list-row-feature';
import {Feature} from "geojson";
import {List} from "immutable";
import {Icon} from "antd";
import {customSort} from "../utils/customSort";

interface IProps {
    layerId: string;
    layerName: string;
    className?: string;
    expanded?: boolean;
    visible?: boolean;
    loading?: boolean;
    features?: Feature[];
    selectedFeatures?: List<Feature>;
    toggleLayer: (layer: string) => void;
    editLayer: (layer: string) => void;
    deleteLayer: (layer: string) => void;
    editing: boolean;
    toggleFeatureForLayer?: (feature: any) => void
    panToFeature?: (feature: any) => void;
}

interface IState {
    expanded: boolean;
}

export default class LayerListRow extends PureComponent <IProps, IState> {
    static getDerivedStateFromProps (props: IProps, state: IState) {
        if (props.expanded && !state.expanded) {
            return {expanded: props.expanded};
        }
        return null;
    }

    state = {
        expanded: false,
    }

    toggleLayer = () => {
        if (this.props.loading) return;
        this.props.toggleLayer(this.props.layerId);
    }

    editLayer = () => {
        this.props.editLayer(this.props.layerId);
    }

    deleteLayer = () => {
        this.props.deleteLayer(this.props.layerId);
    }

    toggleExpandLayer = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    toggleFeature = () => {
        this.props.toggleFeatureForLayer!(this.props.layerId)
    }

    render () {
        const {className = '', features=[], selectedFeatures, layerId,
            layerName, visible, loading, editing, panToFeature} = this.props;
        const { expanded = false } = this.state;
        // const expandedClass = expanded ? 'fa-caret-down' : 'fa-caret-right';
        const expandedType = expanded ? 'caret-down' : 'caret-right';
        const visibleClass = visible ? 'fa-eye btn' : 'fa-eye-slash btn';
        const loadingClass = 'fa-spinner fa-spin';
        const layerStateClass = `fas ${loading ? loadingClass : visibleClass}`
        // const visibleType = visible ? 'eye' : 'eye-invisible';
        const theme = 'filled';
        return (
            <div className={`${className}`} id={`layerListRow_${layerId}`}>
                <div className={'layerListRow'}>
                    <div className={'layerListRowTitle'}>
                        <div className={'btn'}>
                            <Icon type={expandedType} onClick={this.toggleExpandLayer}/>
                            <span> {layerName}</span>
                        </div>
                    </div>
                    {!editing &&
                        <div className={`layerListRowMenu`}>
                            {/*<Icon type={visibleType} theme={'filled'} onClick={this.toggleLayer}/>*/}
                            <span className={`${layerStateClass}`} onClick={this.toggleLayer}/>
                        </div>
                    }
                    {editing &&
                        <div className={`layerListRowMenu`}>
                            <Icon className={'btn'} type={'edit'} theme={theme} onClick={this.editLayer}/>
                            <Icon className={'btn'} type={'delete'} theme={theme} onClick={this.deleteLayer}/>
                            {/*<span className={`btn fas fa-pencil-alt`} onClick={this.editLayer}/>*/}
                            {/*<span className={`btn fas fa-trash`} onClick={this.deleteLayer}/>*/}
                        </div>
                    }

                </div>
                {expanded && features.map((feature, i) =>
                    <LayerListRowFeature
                        key={`${layerId}_${i}`}
                        className={getSelectedClass(selectedFeatures!, feature)}
                        feature={feature}
                        layerId={layerId}
                        panToFeature={panToFeature}
                    />)}
            </div>
        );
    }
}

function getSelectedClass (selectedFeatures: List<Feature>, feature: any) {
    const a = selectedFeatures &&
        selectedFeatures.size &&
        selectedFeatures.getIn([0, 'properties', 'fullUid']) === feature.getIn(['properties', 'fullUid']);
    return a ? 'selected' : '';
}